import { Flex, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../Components/Button"

const { Title, Text } = Typography

const KIND_CONFIG = {
  activate: {
    title: "Activate this partner perk?",
    content: (name) => `This will make the partner perk ${name} available to all eligible users.`,
    okText: "Activate",
    danger: false
  },
  deactivate: {
    title: "Deactivate this partner perk?",
    content: (name) =>
      `This will remove the partner perk ${name} from the page for all eligible users.`,
    okText: "Deactivate",
    danger: false
  },
  delete: {
    title: "Delete this perk?",
    content: (name) => `This will permanently remove ${name}. This action cannot be undone.`,
    okText: "Delete",
    danger: false
  }
}

const ConfirmModal = ({ open, kind, record, loading, onConfirm, onCancel }) => {
  const { t } = useTranslation()
  const cfg = KIND_CONFIG[kind]

  if (!cfg) return null

  return (
    <Modal
      className="perks-confirm-modal"
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={420}
      destroyOnHidden
      maskClosable={false}
      data-testid="confirm-modal"
    >
      <Title level={4} style={{ marginTop: 0, marginBottom: 8 }}>
        {t(cfg.title)}
      </Title>
      <Text style={{ wordBreak: "break-word" }} type="secondary">
        {t(cfg.content(record?.partner_name || ""))}
      </Text>
      <Flex justify="flex-end" gap={8} style={{ marginTop: 24 }}>
        <Button onClick={onCancel} disabled={loading} data-testid="confirm-modal-cancel-btn">
          {t("Cancel")}
        </Button>
        <Button
          type="primary"
          danger={cfg.danger}
          loading={loading}
          onClick={onConfirm}
          data-testid="confirm-modal-confirm-btn"
        >
          {t(cfg.okText)}
        </Button>
      </Flex>
    </Modal>
  )
}

export default ConfirmModal
